const YOUTUBE_REG_EXP =
  /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;

export default YOUTUBE_REG_EXP;
